export const RECAPTCHA_ERROR_CODE = 301;
export const DELAY_FOR_RECAPTCHA_REQUEST = 200;
